import { useCallback, useState } from 'react';
import { authApi } from '../../api/auth';
import { GQLArgs } from '../../types';

type UMALogin = { createSessionWithUmaToken: { token: string } };

export const useMutationUMALogin = (args?: GQLArgs<UMALogin>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UMALogin | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { umaToken: string } }) => {
      setLoading(true);
      try {
        const res = await authApi.loginUma(variables.umaToken);
        const token = res.data.token;
        localStorage.setItem('token', token);
        const shaped: UMALogin = { createSessionWithUmaToken: { token } };
        setData(shaped);
        args?.onCompleted?.(shaped);
        return shaped;
      } catch (err: any) {
        // eslint-disable-next-line no-console
        console.error('UMA Login Error:', err);
        // eslint-disable-next-line no-console
        console.error('Error response:', err?.response?.data);
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
